import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { isUserLoggedIn } from '@app/app.reducer';
import { Store, select } from '@ngrx/store';
import { ResetReducer } from '@store/user/user.actions';
import { keys, some } from 'lodash';
import { Observable, map, take } from 'rxjs';

@Injectable()
export class LoginGuardSignedOut implements CanActivate {
  readonly #router = inject(Router);
  readonly #store = inject(Store);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.#store.pipe(
      select(isUserLoggedIn),
      map((isLoggedIn) => {
        if (
          some(
            keys(route.queryParams),
            (param) => param.toLowerCase() === 'login_user' || param.toLowerCase() === 'reg_mail'
          )
        ) {
          this.#store.dispatch(new ResetReducer());

          return true;
        }

        if (!isLoggedIn) {
          return true;
        }

        this.#router.navigate(['/']);

        return false;
      }),
      take(1)
    );
  }
}
